export type PushToFIProviderModalCopy = {
    title: string;
    confirmMessage: string;
    successMessage: string;
    failureMessage: string;
    failureSubMessage: string;
};

export type PushToFIProvider = {
    displayName: string;
    creditProviderValue: string;
    targetPlatformId: string;
    slowTimeoutMs: number;
    modalCopy: PushToFIProviderModalCopy;
};

export type PushToFIProviderState = {
    timestamp: string;
    wsResult: { message: string; ok: boolean };
    bffResult: { message: string; ok: boolean };
    status: PushToFIStatus;
    initiatedAt?: number;
    correlationId?: string;
};

export type PushToFIState = {
    [providerId: string]: PushToFIProviderState | undefined;
};

export enum PushToFIStatus {
    Ready = 'ready',
    Waiting = 'waiting',
    Success = 'success',
    Failure = 'failure',
    OfferSaveFailure = 'offerSaveFailure'
}

export const ROUTE_ONE_PROVIDER_CONFIG: PushToFIProvider = {
    displayName: 'RouteOne',
    creditProviderValue: 'r1_dealertrack',
    targetPlatformId: 'R1J',
    slowTimeoutMs: 30000,
    modalCopy: {
        title: 'Push To Route One',
        confirmMessage: 'Make sure all financial and contracting activities have been completed before pushing to RouteOne',
        successMessage: 'Push to Route One was successful.',
        failureMessage: 'Push To Route One Failed.',
        failureSubMessage: 'This deal could not be pushed to RouteOne. Please try again.'
    }
};

export const CUDL_PROVIDER_CONFIG: PushToFIProvider = {
    displayName: 'CUDL',
    creditProviderValue: 'CDL',
    targetPlatformId: 'CDL',
    slowTimeoutMs: 30000,
    modalCopy: {
        title: 'Ready to Continue in CUDL',
        confirmMessage: 'Clicking "Confirm" will update the offer and push the information to CUDL. Do you want to continue?',
        successMessage: 'Push to CUDL was successful.',
        failureMessage: 'Push To CUDL Failed.',
        failureSubMessage: 'This deal could not be pushed to CUDL. Please try again.'
    }
};
